import styled from '@emotion/styled'
import { Search } from 'lucide-react'

export const StyleTableResponsiveWrapper = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const StyleTableWrapper = styled.div<{ borderRadius?: number }>`
  display: flex;
  flex-direction: column;
  background-color: ${(props: any) => props.theme.colors.white};
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  overflow-y: auto;
  border-radius: ${(props: any) => props.borderRadius ?? 12}px;
  height: 100%;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.05),
    0 2px 4px -1px rgba(0, 0, 0, 0.03);
`
export const StyleTableTitle = styled.p`
  font-size: 18px;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.text};
`
export const StyleTableSearchWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  position: relative;
  background-color: ${(props: any) => props.theme.colors.white};
  padding: 16px 20px;
  border-bottom: 1px solid ${(props: any) => props.theme.colors.borderColor};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`
export const StyleTableSearchInput = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid
    ${(props: any) => props.theme.colors?.borderColor || '#e2e8f0'};
  border-radius: 10px;
  outline: none;
  background-color: transparent;
  color: ${(props: any) => props.theme.colors?.text || '#334155'};
  padding: 0 12px 0 35px;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);

  &:hover {
    border-color: ${(props: any) => props.theme.colors?.blue500 || '#004aad'};
  }

  &:focus {
    border-color: ${(props: any) => props.theme.colors?.blue500 || '#004aad'};
    box-shadow: 0 0 0 3px rgba(0, 74, 173, 0.1);
  }

  &::placeholder {
    font-size: 13px;
    color: ${(props: any) => props.theme.colors?.placeholder || '#94a3b8'};
    letter-spacing: 0.25px;
  }
`
export const StyleSearchIcon = styled(Search)`
  color: ${(props: any) => props.theme.colors?.placeholder || '#94a3b8'};
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  pointer-events: none;
`
export const StyledExportButton = styled.button`
  width: 100px;
  height: 30px;
  border-radius: 5px;
  padding: 0 10px;
  background-color: ${(props: any) => props.theme.colors.blue500};
  color: ${(props: any) => props.theme.colors.neutral10};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border: none;
  svg {
    width: 1.4rem;
    transform: translateY(2px);
  }
`

export const StyleTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  min-width: 800px;
`

export const StyleHeadWrapper = styled.thead<{ headerBgColor?: string }>`
  background-color: ${(props: any) =>
    props.headerBgColor || props.theme.colors.primaryLight};
  height: 48px;
  color: ${(props: any) => props.theme.colors.text};
  position: sticky;
  top: 0;
  z-index: 10;
  text-align: left;
`
export const StyleTableRow = styled.tr`
  cursor: pointer;
  transition: background-color 0.2s;
  &:hover {
    background-color: ${(props: any) =>
      props.theme.colors.borderColor}33; // Add slight tint on hover
  }
`
export const StyleHeader = styled.th`
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${(props: any) => props.theme.colors.textGrey};
  padding: 12px 16px;
`
export const StyleBodyWrapper = styled.tbody`
  background-color: ${(props: any) => props.theme.colors.white};
`
export const StyleBodyText = styled.td`
  vertical-align: middle;
  padding: 14px 16px;
  color: ${(props: any) => props.theme.colors.text};
  font-weight: 400;
  font-size: 14px;
  border-bottom: 1px solid ${(props: any) => props.theme.colors.borderColor};
`

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 280px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const Text = styled.div`
  color: ${(props: any) => props.theme.colors.primary};
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0.25px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
`

export const ActionButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;

  svg {
    width: 26px;
    height: 26px;
    color: ${({ theme }: any) => theme.colors.text};
    &:hover {
      color: ${({ theme }: any) => theme.colors.primary};
    }
  }
`
